import React from 'react';
import { Icon } from './Icon.js';
export const IconShapeSquare = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 3H3V21H21V3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconShapeSquare.js.map